<template lang="pug">
  section.canned-response-picker(
    @keyup.esc="closePickerFunction")
    .button-row
      h3.heading Canned Responses
      button.btn.muted.close-picker(
        @click="closePickerFunction"
        title="Close canned responses")
        svg.svgicon(xmlns='http://www.w3.org/2000/svg', viewBox="0 0 320 512")
          path(d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z")

    .list-wrapper
      canned-response-list(
        :source-list-data="cannedResponseSet"
        :use-simple-list="true"
        :trigger-search-input-focus="cannedResponsesShown"
        v-on:select-canned-response="setSelectedResponse")
</template>
<script>
import CannedResponseList from '@/components/coaching/cannedResponses/CannedResponseList.vue';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'CannedResponsePicker',
  props: ['canned-responses-shown', 'close-picker-function'],
  components: {
    CannedResponseList
  },
  data() {
    return {
      cannedResponseSet: [],
      selectedResponse: null
    };
  },
  computed: {
    ...mapGetters(['cannedResponseMessages'])
  },
  methods: {
    init() {
      this.getCannedResponseMessages().then(() => {
        this.cannedResponseSet = this.cannedResponseMessages.slice();
      });
    },
    setSelectedResponse(response) {
      this.$emit('populate-coach-message', response);
      this.selectedResponse = response;
      this.closePickerFunction();
    },
    ...mapActions(['getCannedResponseMessages'])
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
section.canned-response-picker {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: $md-blue-grey-50;

  div.button-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;

    .heading {
      align-self: top;
    }

    button.close-picker {
      padding: 11px 11px 10px;

      svg {
        margin-right: 0;
        height: 24px;
        width: 24px;
      }
    }
  }

  .list-wrapper {
    font-size: 18px;
  }
}
</style>
